import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
  zipDownload(imgArr) {
    let zip = new JSZip();
    for (let i = 0; i < imgArr.length; i++) {
      zip.file(imgArr[i].name + ".png", imgArr[i].img.split(",")[1], { base64: true });

    }
    this.downImg(zip);
  },
  downImg(zip) {
    zip.generateAsync({
      type: "blob"
    })
      .then(content => {
        let fileName = "批量下载.zip";
        FileSaver.saveAs(content, fileName);
      });
  },
  //****传入图片链接，返回base64数据
  getBase64Image(url) {
    return new Promise((resolve, reject) => {
      var base64 = "";
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.onload = () => {
        base64 = this.image2Base64(img);
        resolve(base64.split(",")[1]);
      };
      img.onerror = () => reject("加载失败");　　 // 这里可能会有跨域失败的问题，解决方案同上，url + 随机数
      img.src = url;
    });
  },
  image2Base64(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, img.width, img.height);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL;
  },
  //****传入文件链接，返回arraybuffer数据
  getFile(url) {
    return new Promise((resolve, reject) => {　　 // 这里的$http是Vue里的axios
      this.$http({
        method: "get",
        url,
        responseType: "arraybuffer"
      })
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject("PDF加载失败：" + error);
        });
    });
  },
}



// WEBPACK FOOTER //
// ./src/utils/fileZipDownload.js